export default (() => {
  if (process.env.VUE_APP_ENV === 'production') {
    return {
      apiKey: "AIzaSyDfxaw1b-W2OQh_D8FwHzskSuq0K0cSOuQ",
      authDomain: "quick-receipts-214623.firebaseapp.com",
      databaseURL: "https://quick-receipts-214623.firebaseio.com",
      projectId: "quick-receipts-214623",
      storageBucket: "quick-receipts-214623.appspot.com",
      messagingSenderId: "68617731019",
      appId: "1:68617731019:web:2dbd5c9d7b157451"
    };
  } else {
    return {
      apiKey: "AIzaSyDRd9i52x0dHKJLGR_gpV8rJnJ-WruD_1s",
      authDomain: "quick-receipts-staging.firebaseapp.com",
      databaseURL: "https://quick-receipts-staging.firebaseio.com",
      projectId: "quick-receipts-staging",
      storageBucket: "quick-receipts-staging.appspot.com",
      messagingSenderId: "825924516324",
      appId: "1:825924516324:web:6ee2d39cd1d32312"
    };
  }
})();